<template>
  <section v-loading.fullscreen.lock="loading" class="course">
    <com-tabs
      v-if="data2"
      :list="data2"
      class="course-tabs"
      :default-tab="activeTab"
      @change="changeTab"
    >
      <template v-slot:text="{ obj }">
        <div
          :class="{ activeTab: activeTab == obj.key }"
          class="course-tabs-item"
        >
          {{ obj.name }}
        </div>
      </template>
    </com-tabs>
    <div v-if="data1" class="course-content">
      <div>
        <span>排课信息</span>
        <el-button
          type="text" @click="handleControl(null, null, 'add')"
        >
          添加排课
        </el-button
        >
      </div>
      <div>
        <span v-for="(item1, index1) in data1" :key="index1">
          <span>{{ item1.date }}</span>
          <span>{{ item1.week }}</span>
        </span>
      </div>
      <div>
        <span v-for="(item1, index1) in data1" :key="index1">
          <el-scrollbar class="width100" wrap-style="overflow-x: hidden;">
            <div
              v-for="(child1, childIndex) in item1.child"
              :key="childIndex"
              class="course-item"
            >
              <span>{{ child1.time_interval }}</span>
              <span>
                <el-tag
                  v-for="(classItem, classIndex) in child1.class"
                  :key="classIndex"
                  size="mini"
                >{{ classItem.name }}</el-tag
                >
              </span>
              <span>
                <el-tag
                  v-for="(teacherItem, teacherIndex) in child1.teacher"
                  :key="teacherIndex"
                  size="mini"
                >{{ teacherItem.name }}</el-tag
                >
              </span>
              <span>{{ child1.sum }}</span>
              <span>
                <i
                  class="el-icon-edit"
                  @click="handleControl(item1, child1, 'edit')"
                />
                <i
                  class="el-icon-delete"
                  @click="handleControl(item1, child1, 'delete')"
                /></span>
            </div>
          </el-scrollbar>
        </span>
      </div>
    </div>
    <div v-else class="course-no-content" @click="handleRoute">
      <i class="el-icon-plus" />
      <span>请添加功能室</span>
    </div>
    <com-add
      :id="add.id"
      v-model="add.show"
      :child-id="add.childId"
      :room-id="add.roomId"
      :rules="mineInfo.obj.rules"
      @input="initType"
    />
  </section>
</template>

<script>
import mock from '@/utils/mock'
import api from '@/api/app'
import comTabs from '@/components/comTabs'
import comAdd from './details/comAdd.vue'
export default {
  components: { comAdd, comTabs },
  data() {
    return {
      mineInfo: mock.mine.course.viewInfo,
      mineInit: mock.mine.course.init,
      loading: false,
      data1: null,
      data2: null,
      activeTab: 0,
      add: {
        show: false,
        id: null,
        childId: null,
        roomId: null
      }
    }
  },
  computed: {},
  created() {
    this.loading = true
    this.initType()
  },
  mounted() {},
  methods: {
    async initType() {
      this.data2 = await this.mineInit.data2()
      if (this.data2.length) {
        this.add.roomId = this.data2[0].id
        this.init()
      } else {
        this.loading = false
      }
    },
    async init() {
      const obj = {}
      obj.room_id = this.add.roomId
      this.data1 = await this.mineInit.data1(obj)
      this.loading = false
    },
    changeTab(x, y) {
      this.activeTab = x
      this.add.roomId = y
      this.init()
    },
    handleRoute() {
      this.$router.push({
        path: '/mine/set',
        query: {
          activeTab: 2
        }
      })
    },
    handleControl(y, v, x) {
      switch (x) {
        case 'add':
          this.add.show = true
          this.add.childId = null
          this.add.id = null
          break
        case 'edit':
          this.add.show = true
          this.add.id = y.id
          this.add.childId = v.id
          break
        default:
          this.$confirm('确认删除该排课吗?', '提示', {})
            .then(() => {
              api.mine.delete.course({ id: v.id }).then(() => {
                this.$message({
                  message: '排课删除成功',
                  type: 'success'
                })
                this.init()
              })
            })
            .catch(() => {})
      }
    },
    control(type, condition) {
      return mock.system.global.control[type](condition)
    }
  }
}
</script>

<style scoped lang="scss">
.course {
  @include fun-layout(1);
  display: flex;
  flex-direction: column;
  &-tabs {
    margin: 0 35px;
    &-item {
      text-align: center;
      @include fun-design(7);
      line-height: 40px;
      width: 60px;
      cursor: pointer;
    }
    .activeTab {
      @include fun-active();
    }
  }
  &-content {
    flex: 1;
    margin-top: 20px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    > div {
      &:nth-child(1) {
        height: 50px;
        line-height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        > button {
          margin-left: 10px;
          color: #2f82ff;
        }
      }
      &:nth-child(2) {
        height: 85px;
        display: flex;
        align-items: center;
        > span {
          flex: 1;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          padding: 20px 0;
          @include fun-border();
          border-right: 0;
          &:last-child {
            @include fun-border();
          }
          > span {
            > i {
              cursor: pointer;
              width: 40px;
              text-align: center;
            }
          }
        }
      }
      &:nth-child(3) {
        flex: 1;
        display: flex;
        align-items: center;
        > span {
          flex: 1;
          height: 520px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          @include fun-border();
          border-right: 0;
          &:last-child {
            @include fun-border();
          }
        }
      }
    }
  }
  &-item {
    display: flex;
    padding-bottom: 5px;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    @include fun-border(0,"bottom");
    position: relative;
    > span {
      padding-top: 5px;
      > i {
        cursor: pointer;
        width: 40px;
        text-align: center;
      }
    }
  }
  > div {
    @include fun-layout(2);
    width: 100%;
    display: flex;
    flex-direction: column;
  }
}
.course-no-content {
  @extend .course-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
